import React, { FC } from "react";
import cn from "classnames";
import { useQueryParams } from "src/hooks/useQueryParams";
import { QUERY_PARAM_KEYS } from "src/constants/queryParams";
import { IBlogCategoty } from "src/@types/blog";
import { QueryParamKeys } from "../../types";

interface Props {
  activeCategory: IBlogCategoty;
  category: IBlogCategoty;
}

export const Category: FC<Props> = ({ activeCategory, category }) => {
  const { deleteQueryParam, setQueryParam } = useQueryParams();

  const isActive = activeCategory.slug === category.slug;

  const onClick = () => {
    const shouldDeleteCategory = category.slug === "all" || isActive;

    if (shouldDeleteCategory) {
      deleteQueryParam(QueryParamKeys.CATEGORY);
    } else {
      setQueryParam(QueryParamKeys.CATEGORY, category.slug);
    }

    setQueryParam(QUERY_PARAM_KEYS.PAGE, 1);
  };

  return (
    <li
      className={cn(
        "text-purple-base text-lg font-bold px-5 py-3 cursor-pointer rounded-20 transition-all duration-300 ease-in-out hover:text-purple-dark",
        {
          "bg-purple-lighter": isActive,
        }
      )}
      onClick={onClick}
    >
      {category.title}
    </li>
  );
};
